<!--
무자료 등록(재고방식) > 상품추가 (리스트) > 상품삭제
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                무자료 상품삭제
            </div>

            <div class="uk-modal-body">
                <div class="uk-flex uk-flex-left uk-flex-top">
                    <div class="uk-width-auto">
                        <div class="uk-margin-right">
                            <img
                                :src="prod.img_url"
                                :data-src="prod.img_url"
                                class="lazyloaded"
                                style="object-fit: contain; width: 150px; height: 150px;"
                            />
                        </div>
                    </div>

                    <div class="uk-width-expand">
                        <!-- 상품정보 테이블 -->
                        <table class="prod-table">
                            <tr>
                                <th class="highlight">
                                    <i class="material-icons">
                                        info
                                    </i>
                                    수량(QTY)
                                </th>
                                <td>
                                    {{ prod.amount }}
                                </td>

                                <th class="highlight">
                                    <i class="material-icons">
                                        info
                                    </i>
                                    사이즈
                                </th>
                                <td>
                                    {{ prod.size }}
                                </td>

                                <th>
                                    <i class="material-icons">
                                        info
                                    </i>
                                    색상
                                </th>
                                <td colspan="3">
                                    {{ prod.color }}
                                </td>
                            </tr>

                            <tr>
                                <th>
                                    <i class="material-icons">
                                        info
                                    </i>
                                    상품명
                                </th>
                                <td colspan="3">
                                    {{ prod.name }}
                                </td>
                                <th>
                                    <i class="material-icons">
                                        receipt
                                    </i>
                                    해외주문번호
                                </th>
                                <td>
                                    {{ prod.buy_order_code }}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <i class="material-icons">
                                        comment
                                    </i>
                                    관리메모
                                </th>
                                <td colspan="3">
                                    {{ prod.memo }}
                                </td>
                                <th>
                                    <i class="material-icons">
                                        comment
                                    </i>
                                    유통기한
                                </th>
                                <td>
                                    {{ prod.expiration_date }}
                                </td>
                            </tr>
                        </table>


                    </div>

                </div>


            </div>


            <div class="uk-modal-footer uk-text-right">
                <div class="confirm-msg">
                    이 상품을 정말 삭제합니까?
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-large uk-button-danger"
                    @click="submit"
                >
                    <span uk-icon="icon: delete"></span>
                    삭제(완료)
                </button>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        // csrf-token
        csrfToken: String,

        // 지역ID
        regionId: Number,

    },
    data: function () {
        return {
            // (object) 상품정보
            prod: {},
        };
    },
    computed: {},
    methods: {
        /**
         * 입력폼 display
         */
        displayForm() {

            UIkit.modal(this.$el).show();
        },

        /**
         * 폼
         * @param prod (object) 상품정보
         */
        form(prod) {
            this.prod = prod;

            // 폼 디스플레이
            this.displayForm();
        },

        /**
         * submit
         */
        submit() {
            // promise 생성
            let p = new Promise((resolve, reject) => {

                // ajax 옵션
                let opts = {
                    type: 'delete',
                    url: '/regions/' + this.regionId + '/nodata-stocks/' + this.prod.id,
                    data: {
                        '_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        reject();
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            });


            // promise 처리
            p.then((response) => {
                this.$emit('removed', this.prod);
                UIkit.modal(this.$el).hide();
            }).catch(() => {
                // 오류인경우
            });
        },


    },


}
</script>


<style lang="scss" scoped>

.uk-modal-dialog {
    width: 80rem;
}

.uk-modal-header {
    font-size: 1.25rem;
    font-weight: bold;
}

// 테이블
.prod-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    th, td {
        padding: 1rem;
        //min-width: 10rem;
        border: 1px solid #cfcfcf;

        text-align: left;
        font-weight: normal;
        color: #000;
    }

    th {
        font-size: 1rem;
        background-color: #fefefe;
        width: 10rem;

        .material-icons {
            vertical-align: middle;
            font-size: 1.5rem;
            color: #aaa;
        }

        &.highlight .material-icons {
            color: #1e87f0 !important;
        }

    }

    td {
        text-align: left;
        font-size: 1rem;
        color: #000;
    }

}

.confirm-msg {
    font-size: 1.25rem;
    color: #ff0000;
}
</style>